export const SORTING_ASC = 'ascending';

export const ClothesAndAccesories = 'ClothesAndAccesories';
